import React from "react";

const DeviceTypeIcon = ({type, customClass, isFab = false}) => {

    let icon = null;
    switch(type) {
        case "PC":
            isFab = true;
            icon = "fa-windows";
            break;
        case "PC Linux":
            isFab = true;
            icon = 'fa-linux';
            break;
        case "LantickPro-4-4":
            icon = 'fa-plug';
            break;
        case "Dali router":
            icon = 'fa-lightbulb';
            break;
        default:
            icon = 'fa-code';
    }
    const prefix = isFab ? "fab " : "fas ";
    return (
        <i className={ prefix + customClass + " " + icon }> </i>
    )

};
export default DeviceTypeIcon;
